//
// https://icon-sets.iconify.design/
//

const Icons = {
  adjustments: "heroicons:adjustments-horizontal",
  arrowDown: "heroicons:arrow-down",
  arrowLeft: "heroicons:arrow-left",
  arrowRight: "heroicons:arrow-right",
  arrowUp: "heroicons:arrow-up",
  banknotes: "heroicons:banknotes",
  bell: "heroicons:bell",
  bolt: "heroicons:bolt",
  cake: "heroicons:cake",
  calendar: "heroicons:calendar-days",
  check: "heroicons:check",
  cheeseMono: "bx:cheese",
  chevronLeft: "heroicons:chevron-left",
  copy: "heroicons:square-2-stack",
  creditCard: "heroicons:credit-card",
  download: "heroicons:arrow-down-tray",
  ellipsisVertical: "heroicons:ellipsis-vertical",
  exclamation: "heroicons:exclamation-circle",
  eye: "heroicons:eye",
  fire: "heroicons:fire",
  gear: "heroicons:cog-8-tooth",
  hamburger: "heroicons:bars-3",
  home: "heroicons:home",
  link: "heroicons:link",
  list: "heroicons:list-bullet",
  loader: "lucide:loader-circle",
  logout: "heroicons:arrow-right-start-on-rectangle",
  monoInstagram: "bi:instagram",
  monoLinkedin: "bi:linkedin",
  monoYoutube: "bi:youtube",
  openWindow: "heroicons:arrow-top-right-on-square",
  party: "fxemoji:partypopper",
  pencil: "bi:pencil",
  person: "heroicons:user-circle",
  plus: "heroicons:plus",
  question: "heroicons:question-mark-circle",
  rocket: "heroicons:rocket-launch",
  shareAndroid: "heroicons:share",
  shareiOS: "heroicons:arrow-up-on-square",
  sort: "heroicons:arrows-up-down",
  star: "heroicons:star",
  starSolid: "heroicons:star-solid",
  trash: "heroicons:trash",
  trophy: "heroicons:trophy",
  xCircle: "heroicons:x-circle",

  // custom
  alarmmouse: "custom:alarmmouse",
  block: "custom:block",
  cheese: "custom:cheese",
  facebook: "custom:facebook",
  instagram: "custom:instagram",
  linkedin: "custom:linkedin",
  reddit: "custom:reddit",
  sparktoro: "custom:sparktoro",
  threads: "custom:threads",
  tiktok: "custom:tiktok",
  twitter: "custom:twitter",
  youtube: "custom:youtube",

  // quiz animals
  beaver: "custom:beaver",
  chipmunk: "custom:chipmunk",
  gopher: "custom:gopher",
  mouse: "custom:alarmmouse",
  hamster: "custom:hamster",
  marmot: "custom:marmot",
  rat: "custom:rat",
  squirrel: "custom:squirrel",
};

export type IconName = keyof typeof Icons;

export default Icons;
